import React, { useId } from "react"
import { Area, AreaChart, CartesianGrid, XAxis, Tooltip, ResponsiveContainer } from "recharts"
import { formatInteger } from "../../../../utils/formatters"
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardAction } from "../../../../components/ui/card"
import { Delta, DeltaIcon, DeltaValue } from "../../../../components/delta"

const FALLBACK_DATA = [
  { month: "January", learners: 120 }, { month: "February", learners: 158 },
  { month: "March", learners: 190 }, { month: "April", learners: 214 },
  { month: "May", learners: 260 }, { month: "June", learners: 301 },
  { month: "July", learners: 289 }, { month: "August", learners: 340 },
  { month: "September", learners: 378 }, { month: "October", learners: 402 },
  { month: "November", learners: 455 }, { month: "December", learners: 498 },
]

const LearnersChart = ({ data, deltaPercent = 12.4 }) => {
  const chartData = data?.length ? data : FALLBACK_DATA
  const total = chartData?.[chartData.length - 1]?.learners ?? 0
  const gradientId = `learners-area-${useId().replace(/[:]/g, "")}`

  return (
    <Card className="md:col-span-2 lg:col-span-3 dark:bg-transparent">
      <CardHeader className="flex-row items-start justify-between">
        <div className="flex flex-col gap-1.5">
          <CardTitle className="font-mono text-2xl tabular-nums">{formatInteger(total)}</CardTitle>
          <CardDescription>Total learners in the last 12 months</CardDescription>
        </div>
        <CardAction>
          <Delta value={deltaPercent} variant="badge">
            <DeltaIcon />
            <DeltaValue />
          </Delta>
        </CardAction>
      </CardHeader>
      <CardContent>
        <div className="h-60 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={chartData} margin={{ left: 0, right: 12, top: 4 }}>
              <defs>
                <linearGradient id={gradientId} x1="0" x2="0" y1="0" y2="1">
                  <stop offset="0%" stopColor="var(--chart-2, #6366f1)" stopOpacity={0.3} />
                  <stop offset="100%" stopColor="var(--chart-2, #6366f1)" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid vertical={false} strokeOpacity={0.15} />
              <XAxis dataKey="month" axisLine={false} tickLine={false} tickMargin={8} tickFormatter={(v) => String(v).slice(0, 3)} fontSize={12} />
              <Tooltip
                formatter={(value) => [formatInteger(value), "Learners"]}
                contentStyle={{ background: "var(--color-card, #fff)", border: "1px solid var(--color-border, #e5e5e5)", borderRadius: 8, fontSize: 12 }}
              />
              <Area dataKey="learners" type="monotone" stroke="var(--chart-2, #6366f1)" strokeWidth={2} fill={`url(#${gradientId})`} dot={false} isAnimationActive={false} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  )
}

export default LearnersChart